import dayjs from "dayjs";

export const selectFormOptions = (options = []) => {
  return options.map((option) => {
    const value = option
      .toLowerCase()
      .replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace("_", " "));
    return {
      value: option,
      label: value.charAt(0).toUpperCase() + value.slice(1)
    };
  });
};

export const selectFormOptionsNoFormatting = (options = []) => {
  return options.map((option) => {
    return {
      value: option,
      label: option
    };
  });
};

export const isDatePast = (current) => {
  return current && current < dayjs().startOf("day");
};

/**
 * The valid slug format. The backend uses the same format.
 * A slug has lowercase letters and digits. A single hyphen can join two parts.
 */
export const SLUG_FORMAT_REGEX = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

/**
 * Converts a string into a clean URL-friendly slug.
 * @example
 * createSlug("Segment Tree"); // "segment-tree"
 */
export const createSlug = (str = "") => {
  return String(str)
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
};
